import styled from "styled-components";
import {Button, Popover, Tabs} from "antd";


export const PickerTabs = styled(Tabs)`
  min-width: 500px;
  width: 640px;
`;

export const TabBody = styled.div`
  height: 200px;
  overflow: auto;
  width: 100%;
  
`;

export const PickerPopover = styled(Popover)`
  .ant-popover-inner {
    padding: 0;
  }
`

export const List = styled.ul`
  height: 200px;

`;
export const Item = styled.li`
  float: left;
  width: 20%;
  text-align: center;
  height: 30px;
  line-height: 30px;
  margin-bottom: 5px;
`;

export const ServerButton = styled.button`
  display: inline-block;
  max-width: 100px;
  padding: 6px 10px;
  font-size: 12px;
  color: #6b6b6b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: .2s;
  background: none;
  border: none;
  cursor: pointer;
  &:active {
    border: none;
  }
  
  &:hover {
    background: #f3730e;
    color: #fff;
    text-decoration: none;
  }
`;


export const ServerPickerButton = styled(Button)`
  min-width: 140px;
  text-align: left;
  padding: 8px 12px;
  height: 36px;
  border-radius: 0;
  color: rgb(78, 78, 78);
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  
`;